import Vue from 'vue'
import Router from 'vue-router'
import i18n from '@/i18n'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

// 公共路由
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/Login'),
    hidden: true
  },
  {
    path: '/web-card',
    component: () => import('@/views/web/index'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/error/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error/401'),
    hidden: true
  },
  // {
  //   path: '',
  //   component: Layout,
  //   redirect: 'dashboard',
  //   children: [
  //     {
  //       path: 'dashboard',
  //       component: () => import('@/views/dashboard'),
  //       name: 'dashboard',
  //       meta: { title: '运营情况', icon: 'dashboard', affix: true }
  //     }
  //   ]
  // },
]

// 动态路由，基于用户权限动态去加载
export const dynamicRoutes = [
  //主页
  {
    path: '/order',
    component: Layout,
    hidden: true,
    permissions: ['order:orderDataStatistics'],
    children: [
      {
        path: 'statistics',
        component: () => import('@/views/order/orderDataStatistics'),
        name: 'orderDataStatistics',
        meta: { title: '订单统计', activeMenu: '/dashboard' }
      }
    ]
  },
  //个人中心
  //账号中心
  {
    path: '/user',
    component: Layout,
    hidden: true,
    permissions: ['system:person:limitUpdate'],
    children: [
      {
        path: 'limitUpdate',
        component: () => import('@/views/users/pay/index'),
        name: 'payConfig',
        meta: { title: '收款额度编辑', activeMenu: '/dashboard' }
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    hidden: true,
    permissions: ['system:limitUpdate:detail'],
    children: [
      {
        path: 'payAccountList',
        component: () => import('@/views/users/account/index'),
        name: 'limitDetails',
        meta: { title: '收款账号详情', activeMenu: '/dashboard' }
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    hidden: true,
    permissions: ['system:person:userAccount'],
    children: [
      {
        path: 'account',
        component: () => import('@/views/users/account'),
        name: 'account',
        meta: { title: '账号中心',titleKey: 'app.router.accountCenter', activeMenu: '/dashboard' }
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    hidden: true,
    permissions: ['system:person:message'],
    children: [
      {
        path: 'messageCenter',
        component: () => import('@/views/users/toMessageCenter'),
        name: 'messageCenter',
        meta: { title: '消息中心', activeMenu: '/dashboard' }
      }
    ]
  },
  //绑定手机号
  {
    path: '/user',
    component: Layout,
    hidden: true,
    permissions: ['person:userAccount:bindPhone'],
    children: [
      {
        path: 'bindPhone/:phone',
        component: () => import('@/views/users/bindingMobile'),
        name: 'bindingMobile',
        meta: { title: '绑定手机号', activeMenu: '/dashboard' }
      }
    ]
  },
  //账号收支明细
  {
    path: '/user',
    component: Layout,
    hidden: true,
    permissions: ['person:userAccount:outInPay'],
    children: [
      {
        path: 'accountList',
        component: () => import('@/views/users/accountDetails'),
        name: 'accountDetails',
        meta: { title: '账号收支明细', activeMenu: '/dashboard' }
      }
    ]
  },
  //账号充值
  {
    path: '/user',
    component: Layout,
    hidden: true,
    permissions: ['person:userAccount:bindPhone'],
    children: [
      {
        path: 'pay',
        component: () => import('@/views/users/onlinepay'),
        name: 'onlinepay',
        meta: { title: '账号充值', activeMenu: '/dashboard' }
      }
    ]
  },
  //实名信息查看
  {
    path: '/user',
    component: Layout,
    hidden: true,
    permissions: ['person:userAccount:authentication'],
    children: [
      {
        path: 'authenticationInfo',
        component: () => import('@/views/users/authenticationInfo'),
        name: 'authenticationInfo',
        meta: { title: '实名信息', activeMenu: '/dashboard' }
      }
    ]
  },
  //去实名
  {
    path: '/user',
    component: Layout,
    hidden: true,
    permissions: ['person:userAccount:authentication'],
    children: [
      {
        path: 'authentication',
        component: () => import('@/views/users/authentication'),
        name: 'authentication',
        meta: { title: '实名认证', activeMenu: '/dashboard' }
      }
    ]
  },
  //充值密码设置
  {
    path: '/user',
    component: Layout,
    hidden: true,
    permissions: ['system:person:chargePassword'],
    children: [
      {
        path: 'rechargePassword',
        component: () => import('@/views/users/rechargePassword'),
        name: 'rechargePassword',
        meta: { title: '设置充值密码',titleKey: 'app.router.setRechargePassword', activeMenu: '/dashboard' }

      }
    ]
  },
  //系统充值
  {
    path: '/user',
    component: Layout,
    hidden: true,
    permissions: ['system:person:systemCharge'],
    children: [
      {
        path: 'systemPay',
        component: () => import('@/views/users/systemPay'),
        name: 'systemPay',
        meta: { title: '系统充值',activeMenu: '/dashboard' }
      }
    ]
  },
  //投诉处理
  {
    path: '/user',
    component: Layout,
    hidden: true,
    permissions: ['message:user:complaints'],
    children: [
      {
        path: 'complaints',
        component: () => import('@/views/users/complaint/index'),
        name: 'complaintList',
        meta: { title: '投诉处理', activeMenu: '/dashboard' }
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    hidden: true,
    permissions: ['message:user:detailComplaints'],
    children: [
      {
        path: 'complaints/detail/:complaintId',
        component: () => import('@/views/users/complaint/info'),
        name: 'complaintInfo',
        meta: { title: '投诉详情', activeMenu: '/dashboard' }
      }
    ]
  },
  //系统管理
  {
    path: '/system/userAuth',
    component: Layout,
    hidden: true,
    permissions: ['system:user:edit'],
    children: [
      {
        path: 'role/:userId(\\d+)',
        component: () => import('@/views/system/user/authRole'),
        name: 'AuthRole',
        meta: { title: '分配角色', activeMenu: '/system/user' }
      }
    ]
  },

  {
    path: '/system/roleAuth',
    component: Layout,
    hidden: true,
    permissions: ['system:role:edit'],
    children: [
      {
        path: 'user/:roleId(\\d+)',
        component: () => import('@/views/system/role/authUser'),
        name: 'AuthUser',
        meta: { title: '分配用户', activeMenu: '/system/role' }
      }
    ]
  },

  {
    path: '/system/dictData',
    component: Layout,
    hidden: true,
    permissions: ['system:dict:list'],
    children: [
      {
        path: 'index/:dictId(\\d+)',
        component: () => import('@/views/system/dict/data'),
        name: 'Data',
        meta: { title: '字典数据', activeMenu: '/system/dict' }
      }
    ]
  },
  
  //agent
  {
    path: '/agent',
    component: Layout,
    hidden: true,
    permissions: ['agent:dashboard'],
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/dashboardAgent'),
        name: 'dashboardAgent',
        meta: { title: '代理商运营情况', activeMenu: '/partners/agent'}
      }
    ]
  },
  {
    path: '/agent',
    component: Layout,
    hidden: true,
    permissions: ['agent:edit'],
    children: [
      {
        path: 'edit',
        component: () => import('@/views/partners/editorAgent'),
        name: 'editorAgent',
        meta: { title: '编辑代理商', activeMenu: '/partners/agent'}
      }
    ]
  },
  {
    path: '/agent',
    component: Layout,
    hidden: true,
    permissions: ['agent:dataProcess'],
    children: [
      {
        path: 'dataProcess/:userId(\\d+)',
        component: () => import('@/views/partners/dataAnalysis'),
        name: 'dataAnalysis',
        meta: { title: '代理商数据分析', activeMenu: '/partners/agent'}
      }
    ]
  },
  {
    path: '/agent',
    component: Layout,
    hidden: true,
    permissions: ['agent:customProduct'],
    children: [
      {
        path: 'customProduct',
        component: () => import('@/views/partners/product/index'),
        name: 'AgentProduct',
        meta: { title: '套餐设置', activeMenu: '/partners/agent'}
      }
    ]
  },
  //device 卡管理
  {
    path: '/card',
    component: Layout,
    hidden: true,
    permissions: ['card:recycle'],
    children: [
      {
        path: 'recycle',
        component: () => import('@/views/device/recovery'),
        name: 'recovery',
        meta: { title: '流量卡回收', titleKey: 'app.router.cardRecovery', activeMenu: '/device/cards'}
      }
    ]
  },
  {
    path: '/card',
    component: Layout,
    hidden: true,
    permissions: ['card:allocation'],
    children: [
      {
        path: 'allocation',
        component: () => import('@/views/device/transfer'),
        name: 'transfer',
        meta: { title: '流量卡分配', titleKey: 'app.router.cardAllocation', activeMenu: '/device/cards'}

      }
    ]
  },
  {
    path: '/card',
    component: Layout,
    hidden: true,
    permissions: ['card:import'],
    children: [
      {
        path: 'import',
        component: () => import('@/views/device/imports'),
        name: 'import',
        meta: { title: '流量卡导入', activeMenu: '/device/cards'}
      }
    ]
  },
  {
    path: '/card',
    component: Layout,
    hidden: true,
    permissions: ['card:qrCode'],
    children: [
      {
        path: 'qrCode',
        component: () => import('@/views/device/codeQR'),
        name: 'codeQR',
        meta: { title: '二维码导出', activeMenu: '/device/cards'}
      }
    ]
  },
  {
    path: '/card',
    component: Layout,
    hidden: true,
    permissions: ['card:speed'],
    children: [
      {
        path: 'speed',
        component: () => import('@/views/device/speed'),
        name: 'speed',
        meta: { title: '卡限速', activeMenu: '/device/speed'}
      }
    ]
  },
  {
    path: '/card',
    component: Layout,
    hidden: true,
    permissions: ['card:info'],
    children: [
      {
        path: 'detail',
        component: () => import('@/views/device/carddetail'),
        name: 'carddetail',
        meta: { title: '流量卡详情',titleKey: 'app.router.cardDetail', activeMenu: '/device/query'}
      }
    ]
  },
  {
    path: '/card',
    component: Layout,
    hidden: true,
    permissions: ['card:sourceFlow:list'],
    children: [
      {
        path: 'groupCard/:groupId',
        component: () => import('@/views/device/group/groupCard'),
        name: 'groupCard',
        meta: { title: '群组流量卡', activeMenu: '/device/sourceFlow'}
      }
    ]
  },
  {
    path: '/card',
    component: Layout,
    hidden: true,
    permissions: ['card:multiNet:list'],
    children: [
      {
        path: 'multiNet/info', 
        component: () => import('@/views/device/multiNet/info/index.vue'),
        name: 'multiNetInfo',
        meta: { title: '组网详情', activeMenu: '/device/multiNet'}
      }
    ]
  },
  {
    path: '/card',
    component: Layout,
    hidden: true,
    permissions: ['order:multiNet:order'],
    children: [
      {
        path: 'multiNet/order', 
        component: () => import('@/views/device/multiNet/order/index.vue'),
        name: 'multiNetOrder',
        meta: { title: '组网续费', activeMenu: '/device/multiNet'}
      }
    ]
  },
  {
    path: '/card',
    component: Layout,
    hidden: true,
    permissions: ['card:multiNet:migrate'],
    children: [
      {
        path: 'multiNet/turnProduct',
        component: () => import('@/views/device/multiNet/product/turn.vue'),
        name: 'multiNetTurnProduct',
        meta: { title: '组网套餐迁移', activeMenu: '/device/multiNet'}
      }
    ]
  },
  {
    path: '/card',
    component: Layout,
    hidden: true,
    permissions: ['card:multiNet:allocation'],
    children: [
      {
        path: 'multiNet/allocation',
        component: () => import('@/views/device/multiNet/allocation/index.vue'),
        name: 'multiNetAllocation',
        meta: { title: '组网卡分配', activeMenu: '/device/multiNet'}
      }
    ]
  },
  {
    path: '/card',
    component: Layout,
    hidden: true,
    permissions: ['card:multiNet:recycle'],
    children: [
      {
        path: 'multiNet/recycle',
        component: () => import('@/views/device/multiNet/recycle/index.vue'),
        name: 'multiNetRecycle',
        meta: { title: '组网卡回收', activeMenu: '/device/multiNet'}  
      }
    ]
  },
  {
    path: '/card',
    component: Layout,
    hidden: true,
    permissions: ['card:multiNet:batchSwitch'],
    children: [
      {
        path: 'multiNet/switch',
        component: () => import('@/views/device/multiNet/switch/index.vue'),
        name: 'multiNetSwitch',
        meta: { title: '组网批量换卡', activeMenu: '/device/multiNet'}
      }
    ]
  },
  {
    path: '/card',
    component: Layout,
    hidden: true,
    permissions: ['card:multiNet:batchUnpack'],
    children: [{
      path: 'multiNet/unpack',
      component: () => import('@/views/device/multiNet/unpack/index.vue'),
      name: 'multiNetUnpack',
      meta: { title: '组网批量拆网', activeMenu: '/device/multiNet' }
    }]
  },
  // 卡库存记录
  {
    path: '/device',
    component: Layout,
    hidden: true,
    permissions: ['card:inventory:list'],
    children: [
      {
        path: 'inventory',
        component: () => import('@/views/device/inventory/index.vue'),
        name: 'cardInventory',
        meta: { title: '卡库存记录', titleKey: 'app.router.cardInventory', activeMenu: '/device/cards' }
      }
    ]
  },
  {
    path: '/international',
    component: Layout,
    hidden: true,
    permissions: ['card:info'],
    children: [
      {
        path: 'internationalDetail',
        component: () => import('@/views/international/detail'),
        name: 'cardInternationalDetail',
        meta: { title: '流量卡详情',titleKey: 'app.router.internationalDetail', activeMenu: '/international/card'}
      }
    ]
  },
  //订单管理
  {
    path: '/order',
    component: Layout,
    hidden: true,
    permissions: ['card:info'],
    children: [
      {
        path: 'renewal',
        component: () => import('@/views/order/packageRenewal'),
        name: 'packageRenewal',
        meta: { title: '套餐续费', titleKey: 'app.router.packageRenewal', activeMenu: '/order/orderlist'}
      }
    ]
  },
  {
    path: '/card',
    component: Layout,
    hidden: true,
    permissions: ['card:updateCarrierStatus'],
    children: [
      {
        path: 'carrierStatus',
        component: () => import('@/views/device/cardCarrierStatus'),
        name: 'carrierStatus',
        meta: { title: '运营商卡状态修改', activeMenu: '/device/cards'}
      }
    ]
  },
  {
    path: '/order',
    component: Layout,
    hidden: true,
    permissions: ['card:change:detail'],
    children: [
      {
        path: 'newCard/:id',
        component: () => import('@/views/order/replacementDetails'),
        name: 'replacementDetails',
        meta: { title: '补卡详情', activeMenu: '/order/replacementList'}
      }
    ]
  },
  {
    path: '/order',
    component: Layout,
    hidden: true,
    permissions: ['order:refund:detail'],
    children: [
      {
        path: 'refundDetail',
        component: () => import('@/views/order/refundDetails'),
        name: 'refundDetails',
        meta: { title: '退款详情', activeMenu: '/order/refundList'}
      }
    ]
  },
  {
    path: '/order',
    component: Layout,
    hidden: true,
    permissions: ['order:invoice:detail'],
    children: [
      {
        path: 'invoiceDetail/:id',
        component: () => import('@/views/order/invoiceDetail'),
        name: 'invoiceDetail',
        meta: { title: '发票详情', activeMenu: '/order/invoiceManage'}
      }
    ]
  },
  {
    path: '/userCenter',
    component: Layout,
    hidden: true,
    permissions: ['card:info'],
    children: [
      {
        path: 'renewalDetails',
        component: () => import('@/views/userCenter/renewalDetails'),
        name: 'renewalDetails',
        meta: { title: '自动续费详情', activeMenu: '/userCenter/autoRenewalList'}
      }
    ]
  },
  //用户中心
  {
    path: '/userCenter',
    component: Layout,
    hidden: true,
    permissions: ['user:wxBind:detail'],
    children: [
      {
        path: 'bindInfo/:userId',
        component: () => import('@/views/userCenter/userDetail'),
        name: 'userBindInfo',
        meta: { title: '用户绑定列表', activeMenu: '/userCenter/userBindList'}
      }
    ]
  },
  //小程序用户中心
  {
    path: '/userCenter',
    component: Layout,
    hidden: true,
    permissions: ['user:wxMpUser:detail'],
    children: [
      {
        path: 'wxMpUserInfo/:userId',
        component: () => import('@/views/userCenter/wxmpUserDetail'),
        name: 'WxMpUserInfo',
        meta: { title: '小程序用户列表', activeMenu: '/userCenter/wxmpUserList'}
      }
    ]
  },
  //流量池
  {
    path: '/pondManage',
    component: Layout,
    hidden: true,
    permissions: ['pondManage:add'],
    children: [
      {
        path: 'add',
        component: () => import('@/views/pondManage/pondAdd'),
        name: 'pondAdd',
        meta: { title: '流量池新增', activeMenu: '/pondManage/pondList'}
      }
    ]
  },
  {
    path: '/pondManage',
    component: Layout,
    hidden: true,
    permissions: ['pondManage:view'],
    children: [
      {
        path: 'detail',
        component: () => import('@/views/pondManage/pondDetails'),
        name: 'pondDetails',
        meta: { title: '流量池详情', activeMenu: '/pondManage/pondList'}
      }
    ]
  },
  {
    path: '/pondManage',
    component: Layout,
    hidden: true,
    permissions: ['pondManage:edit'],
    children: [
      {
        path: 'edit',
        component: () => import('@/views/pondManage/pondEdit'),
        name: 'pondEdit',
        meta: { title: '流量池编辑', activeMenu: '/pondManage/pondList'}
      }
    ]
  },
  {
    path: '/pondManage',
    component: Layout,
    hidden: true,
    permissions: ['pondManage:add'],
    children: [
      {
        path: 'copy',
        component: () => import('@/views/pondManage/pondAdd'),
        name: 'pondAdd',
        meta: { title: '流量池新增', activeMenu: '/pondManage/pondList'}
      }
    ]
  },
  {
    path: '/pondManage',
    component: Layout,
    hidden: true,
    permissions: ['pondManage:renewal'],
    children: [
      {
        path: 'renewal',
        component: () => import('@/views/pondManage/pondRenewal'),
        name: 'pondRenewal',
        meta: { title: '流量池续约', activeMenu: '/pondManage/pondList'}
      }
    ]
  },
  {
    path: '/pondManage',
    component: Layout,
    hidden: true,
    permissions: ['pondManage:allocation'],
    children: [
      {
        path: 'transfer',
        component: () => import('@/views/pondManage/pondTransfer'),
        name: 'pondTransfer',
        meta: { title: '流量池卡分配', activeMenu: '/pondManage/pondList'}
      }
    ]
  },
  {
    path: '/pondManage',
    component: Layout,
    hidden: true,
    permissions: ['pondManage:recycle'],
    children: [
      {
        path: 'recovery',
        component: () => import('@/views/pondManage/pondRecovery'),
        name: 'pondRecovery',
        meta: { title: '流量池卡回收', activeMenu: '/pondManage/pondList'}
      }
    ]
  },
  {
    path: '/pondManage',
    component: Layout,
    hidden: true,
    permissions: ['pondManage:poolCardStopWarn'],
    children: [
      {
        path: 'poolCardStopWarn/:userId',
        component: () => import('@/views/pondManage/poolCardStopWarn'),
        name: 'poolCardStopWarn',
        meta: { title: '流量池停机预警', activeMenu: '/dashboardpool'}
      }
    ]
  },
  //套餐管理
  {
    path: '/package',
    component: Layout,
    hidden: true,
    permissions: ['product:add'],
    children: [
      {
        path: 'add',
        component: () => import('@/views/package/add'),
        name: 'packageAdd',
        meta: { title: '套餐新增', activeMenu: '/package/packagelist'}
      }
    ]
  },
  
  {
    path: '/package',
    component: Layout,
    hidden: true,
    permissions: ['product:edit'],
    children: [
      {
        path: 'edit/:id',
        component: () => import('@/views/package/edit'),
        name: 'packageEdit',
        meta: { title: '套餐编辑', activeMenu: '/package/packagelist'}
      }
    ]
  },
  {
    path: '/package',
    component: Layout,
    hidden: true,
    permissions: ['product:add'],
    children: [
      {
        path: 'copy/:id',
        component: () => import('@/views/package/copy'),
        name: 'packageCopy',
        meta: { title: '套餐新增', activeMenu: '/package/packagelist'}
      }
    ]
  },
  //国际套餐管理
  {
    path: '/internationalProduct',
    component: Layout,
    hidden: true,
    permissions: ['internationalProduct:add'],
    children: [
      {
        path: 'add',
        component: () => import('@/views/international/product/add'),
        name: 'internationalProductAdd',
        meta: { title: '国际套餐新增', activeMenu: '/international/product/list'}
      }
    ]
  },
  //国际套餐修改
  {
    path: '/internationalProduct',
    component: Layout,
    hidden: true,
    permissions: ['internationalProduct:edit'],
    children: [
      {
        path: 'edit/:id',
        component: () => import('@/views/international/product/edit'),
        name: 'internationalProductEdit',
        meta: { title: '国际套餐修改', activeMenu: '/international/product/list'}
      }
    ]
  },
  {
    path: '/internationalProduct',
    component: Layout,
    hidden: true,
    permissions: ['internationalProduct:copy'],
    children: [
      {
        path: 'copy/:id',
        component: () => import('@/views/international/product/edit'),
        name: 'internationalProductEdit',
        meta: { title: '国际套餐新增', activeMenu: '/international/product/list'}
      }
    ]
  },
  {
    path: '/internationalCustomizeCardProduct',
    component: Layout,
    hidden: true,
    permissions: ['internationalCardProduct:add'],
    children: [
      {
        path: 'add',
        component: () => import('@/views/international/cards/product/internationalCustomizeCardProduct'),
        name: 'internationalCustomizeCardProduct',
        meta: { title: '批量添加国际自定义套餐', activeMenu: 'international/internationalCardProduct'}
      }
    ]
  },
  {
    path: '/package',
    component: Layout,
    hidden: true,
    permissions: ['package:manage:operateCardOrder'],
    children: [
      {
        path: 'operation',
        component: () => import('@/views/package/packageOperation'),
        name: 'packageOperation',
        meta: { title: '套餐操作', activeMenu: '/package/packagelist'}
      }
    ]
  },
  {
    path: '/package',
    component: Layout,
    hidden: true,
    permissions: ['package:manage:operateCardOrder'],
    children: [
      {
        path: 'transferProduct',
        component: () => import('@/views/package/transferProduct'),
        name: 'transferProduct',
        meta: { title: '批量转套餐', activeMenu: '/package/packagelist'}
      }
    ]
  },
  {
    path: '/scheme',
    component: Layout,
    hidden: true,
    permissions: ['scheme:add'],
    children: [
      {
        path: 'operation/add',
        component: () => import('@/views/scheme/add'),
        name: 'schemeAdd',
        meta: { title: '新增方案', activeMenu: '/scheme/list'}
      }
    ]
  },
  {
    path: '/scheme',
    component: Layout,
    hidden: true,
    permissions: ['scheme:add'],
    children: [
      {
        path: 'operation/view/:id',
        component: () => import('@/views/scheme/info'),
        name: 'schemeInfo',
        meta: { title: '方案详情', activeMenu: '/scheme/list'}
      }
    ]
  },
  {
    path: '/scheme',
    component: Layout,
    hidden: true,
    permissions: ['scheme:add'],
    children: [
      {
        path: 'operation/subAdd/:id',
        component: () => import('@/views/scheme/sub/addScheme'),
        name: 'schemeAdd',
        meta: { title: '新增方案', activeMenu: '/scheme/list'}
      }
    ]
  },
  {
    path: '/scheme',
    component: Layout,
    hidden: true,
    permissions: ['scheme:add'],
    children: [
      {
        path: 'operation/edit/:id',
        component: () => import('@/views/scheme/edit'),
        name: 'edit',
        meta: { title: '修改方案', activeMenu: '/scheme/list'}
      }
    ]
  },
  {
    path: '/scheme',
    component: Layout,
    hidden: true,
    permissions: ['scheme:add'],
    children: [
      {
        path: 'operation/subEdit/:id',
        component: () => import('@/views/scheme/sub/editScheme'),
        name: 'editScheme',
        meta: { title: '修改方案', activeMenu: '/scheme/list'}
      }
    ]
  },
  {
    path: '/scheme',
    component: Layout,
    hidden: true,
    permissions: ['scheme:add'],
    children: [
      {
        path: 'ratio/add/:userId',
        component: () => import('@/views/scheme/ratio/add'),
        name: 'ratioSchemeAdd',
        meta: { title: '新增比例方案', activeMenu: '/agent/customProduct'}
      }
    ]
  },
  //认证管理
  {
    path: '/authentication',
    component: Layout,
    hidden: true,
    permissions: ['company:authentication:detail'],
    children: [
      {
        path: 'detail/:id',
        component: () => import('@/views/authentication/certification'),
        name: 'certification',
        meta: { title: '公司认证详情', activeMenu: '/authentication/authenticationList'}
      }
    ]
  },
  {
    path: '/authentication',
    component: Layout,
    hidden: true,
    permissions: ['authentication:card:detail'],
    children: [
      {
        path: 'cardAuth/:id',
        component: () => import('@/views/authentication/cardInformation'),
        name: 'cardInformation',
        meta: { title: '卡认证详情', activeMenu: '/authentication/auths'}
      }
    ]
  },
  {
    path: '/authentication',
    component: Layout,
    hidden: true,
    permissions: ['company:authentication:userAuth'],
    children: [
      {
        path: 'userAuth',
        component: () => import('@/views/users/authentication'),
        name: 'authentication',
        meta: { title: '企业认证', activeMenu: '/scale/withdraw'}
      }
    ]
  },
  {
    path: '/authentication',
    component: Layout,
    hidden: true,
    permissions: ['company:authentication:info'],
    children: [
      {
        path: 'userAuthInfo',
        component: () => import('@/views/users/authenticationInfo'),
        name: 'authenticationInfo',
        meta: { title: '企业认证详情', activeMenu: '/scale/withdraw'}
      }
    ]
  },
  //财务管理
  {
    path: '/scale',
    component: Layout,
    hidden: true,
    permissions: ['scale:withdraw:detail'],
    children: [
      {
        path: 'withdrawDetail/:id',
        component: () => import('@/views/scale/withdrawRecordDetail'),
        name: 'withdrawRecordDetail',
        meta: { title: '分润提现审核', activeMenu: '/scale/audit'}
      }
    ]
  },
  //流程管理
  {
    path: '/procedure',
    component: Layout,
    hidden: true,
    permissions: ['procedure:flowCase:history'],
    children: [
      {
        path: 'history/:id',
        component: () => import('@/views/procedure/lcslHistory'),
        name: 'lcslHistory',
        meta: { title: '历史流程', activeMenu: '/procedure/flowCase'}
      }
    ]
  },
  //个人办公
  {
    path: '/personalOffice',
    component: Layout,
    hidden: true,
    permissions: ['personalOffice:myMission:transaction'],
    children: [
      {
        path: 'taskTransaction/:processId/:id',
        component: () => import('@/views/personalOffice/taskTransaction'),
        name: 'taskTransaction',
        meta: { title: '任务办理', activeMenu: '/personalOffice/myMission'}
      }
    ]
  },
  //平台设置
  {
    path: '/platformSetting',
    component: Layout,
    hidden: true,
    permissions: ['platformSetting:add'],
    children: [
      {
        path: 'add',
        component: () => import('@/views/platformSetting/platformForm'),
        name: 'platformForm',
        meta: { title: '平台新增', activeMenu: '/platformSetting/platformIndex'}
      }
    ]
  },
  {
    path: '/platformSetting',
    component: Layout,
    hidden: true,
    permissions: ['platformSetting:edit'],
    children: [
      {
        path: 'edit/:id',
        component: () => import('@/views/platformSetting/platformForm'),
        name: 'platformForm',
        meta: { title: '平台新增', activeMenu: '/platformSetting/platformIndex'}
      }
    ]
  },
  {
    path: '/platformSetting',
    component: Layout,
    hidden: true,
    permissions: ['platformSetting:user'],
    children: [
      {
        path: 'userSetting/:userId',
        component: () => import('@/views/userMpp/index'),
        name: 'userSetting',
        meta: { title: '企业平台配置', activeMenu: '/platformSetting/platformIndex'}
      }
    ]
  },
  {
    path: '/platformSetting',
    component: Layout,
    hidden: true,
    permissions: ['platformSetting:user'],
    children: [
      {
        path: 'setting',
        component: () => import('@/views/userMpp/index'),
        name: 'userSetting',
        meta: { title: '企业平台配置', activeMenu: '/platformSetting/platformIndex'}
      }
    ]
  },
  //帮助中心
  {
    path: '/helpCenter',
    component: Layout,
    hidden: true,
    permissions: ['help:center:helpAdd'],
    children: [
      {
        path: 'help/add',
        component: () => import('@/views/helpCenter/addHelp'),
        name: 'addHelp',
        meta: { title: '问题新增', activeMenu: '/helpCenter/help'}
      }
    ]
  },
  {
    path: '/helpCenter',
    component: Layout,
    hidden: true,
    permissions: ['help:center:helpEdit'],
    children: [
      {
        path: 'help/edit/:id',
        component: () => import('@/views/helpCenter/editHelp'),
        name: 'editHelp',
        meta: { title: '问题编辑', activeMenu: '/helpCenter/help'}
      }
    ]
  },

  //新闻管理
  {
    path: '/news',
    component: Layout,
    hidden: true,
    permissions: ['news:edit'],
    children: [
      {
        path: 'edit/:id',
        component: () => import('@/views/news/edit'),
        name: 'newsEdit',
        meta: { title: '新闻编辑', activeMenu: '/news/list'}
      }
    ]
  },
  {
    path: '/news',
    component: Layout,
    hidden: true,
    permissions: ['news:add'],
    children: [
      {
        path: 'add',
        component: () => import('@/views/news/add'),
        name: 'newsAdd',
        meta: { title: '新闻新增', activeMenu: '/news/list'}
      }
    ]
  },

  //通道新增
  {
    path: '/card',
    component: Layout,
    hidden: true,
    permissions: ['card:info'],
    children: [
      {
        path: 'channelAdd',
        component: () => import('@/views/device/channelAdd'),
        name: 'AddChannel',
        meta: { title: '创建通道', activeMenu: '/device/channelList' }
      }
    ]
  },
  //通道编辑
  {
    path: '/card',
    component: Layout,
    hidden: true,
    permissions: ['card:info'],
    children: [
      {
        path: 'channelEdit/:channelId(\\d+)',
        component: () => import('@/views/device/channelEdit.vue'),
        name: 'EditChannel',
        meta: { title: '编辑通道', activeMenu: '/device/channelList' }
      }
    ]
  },
  // 卡申请详情
  {
    path: '/device',
    component: Layout,
    hidden: true,
    permissions: ['cardTrial:view'],
    children: [
      {
        path: 'cardTrialDetail/:orderNum',
        component: () => import('@/views/device/cardTrialDetail'),
        name: 'cardTrialDetail',
        meta: { title: '卡申请详情', activeMenu: '/device/cardTrial'}
      }
    ]
  },


  //新增客户信息
  {
    path: '/customerInformation',
    component: Layout,
    hidden: true,
    permissions: ['customer:information:add'],
    children: [
      {
        path: 'customerInformationAdd',
        component: () => import('@/views/customerInformation/customerInformationAdd'),
        name: 'customerInformationAdd',
        meta: { title: '新增客户信息', activeMenu: '/shipment/customerInformation' }
      }
    ]
  },
  //修改客户信息
  {
    path: '/customerInformation',
    component: Layout,
    hidden: true,
    permissions: ['customer:information:update'],
    children: [
      {
        path: 'customerInformationUpdate',
        component: () => import('@/views/customerInformation/customerInformationUpdate'),
        name: 'customerInformationUpdate',
        meta: { title: '修改客户信息', activeMenu: '/shipment/customerInformation' }
      }
    ]
  },

  //客户流程审核
  {
    path: '/customerInformation',
    component: Layout,
    hidden: true,
    permissions: ['customer:information:verify'],
    children: [
      {
        path: 'flowCustomerAct',
        component: () => import('@/views/customerInformation/flowCustomerAct'),
        name: 'flowCustomerAct',
        meta: { title: '审批流程', activeMenu: '/shipment/customerInformation' }
      }
    ]
  },

  //客户流程视图
  {
    path: '/customerInformation',
    component: Layout,
    hidden: true,
    permissions: ['customer:information:flowView'],
    children: [
      {
        path: 'customerInformationFlowView',
        component: () => import('@/views/customerInformation/customerInformationFlowView'),
        name: 'customerInformationFlowView',
        meta: { title: '查看流程', activeMenu: '/shipment/customerInformation' }
      }
    ]
  },

  {
    path: '/customerInformation',
    component: Layout,
    hidden: true,
    permissions: ['customer:information'],
    children: [
      {
        path: 'customerInformationDetail',
        component: () => import('@/views/customerInformation/customerInformationDetail'),
        name: 'customerInformationDetail',
        meta: { title: '详细信息', activeMenu: '/shipment/customerInformation' }
      }
    ]
  },
  
  //新增发货申请页面
  {
    path: '/shipmentRequest',
    component: Layout,
    hidden: true,
    permissions: ['shipment:request:add'],
    children: [
      {
        path: 'shipmentRequestAdd',
        component: () => import('@/views/shipmentRequest/shipmentRequestAdd'),
        name: 'shipmentRequestAdd',
        meta: { title: '新增发货申请页面', activeMenu: '/shipment/shipmentRequest' }
      }
    ]
  },
  //编辑发货申请页面
  {
    path: '/shipmentRequest',
    component: Layout,
    hidden: true,
    permissions: ['shipment:request:update'],
    children: [
      {
        path: 'shipmentRequestUpdate',
        component: () => import('@/views/shipmentRequest/shipmentRequestUpdate'),
        name: 'shipmentRequestUpdate',
        meta: { title: '修改发货申请页面', activeMenu: '/shipment/shipmentRequest' }
      }
    ]
  },

  //发货单流程视图
  {
    path: '/shipmentRequest',
    component: Layout,
    hidden: true,
    permissions: ['shipment:request:flowView'],
    children: [
      {
        path: 'shipmentFlowView',
        component: () => import('@/views/shipmentRequest/shipmentFlowView'),
        name: 'shipmentFlowView',
        meta: { title: '流程信息', activeMenu: '/shipment/shipmentRequest' }
      }
    ]
  },
  {
    path: '/shipmentRequest',
    component: Layout,
    hidden: true,
    permissions: ['shipment:request:verify'],
    children: [
      {
        path: 'flowShipmentAct',
        component: () => import('@/views/shipmentRequest/flowShipmentAct'),
        name: 'flowShipmentAct',
        meta: { title: '审批流程', activeMenu: '/shipment/shipmentRequest' }
      }
    ]
  },

  {
    path: '/shipmentRequest',
    component: Layout,
    hidden: true,
    permissions: ['shipment:outEntrepot:update'],
    children: [
      {
        path: 'outEntrepotUpdate',
        component: () => import('@/views/shipmentRequest/outEntrepotUpdate'),
        name: 'outEntrepotUpdate',
        meta: { title: '制出库单', activeMenu: '/shipment/shipmentRequest' }
      }
    ]
  },

  {
    path: '/shipmentRequest',
    component: Layout,
    hidden: true,
    permissions: ['shipment:request'],
    children: [
      {
        path: 'shipmentRequestDetail',
        component: () => import('@/views/shipmentRequest/shipmentDetail'),
        name: 'shipmentDetail',
        meta: { title: '详细信息', activeMenu: '/shipment/shipmentRequest' }
      }
    ]
  },

  {
    path: '/outEntrepot',
    component: Layout,
    hidden: true,
    permissions: ['shipment:outEntrepot'],
    children: [
      {
        path: 'outEntrepotDetail',
        component: () => import('@/views/shipmentRequest/outEntrepotDetail'),
        name: 'outEntrepotDetail',
        meta: { title: '详细信息', activeMenu: '/shipment/outEntrepot' }
      }
    ]
  },
  {
    path: '/outEntrepot',
    component: Layout,
    hidden: true,
    permissions: ['shipment:outEntrepot:flowView'],
    children: [
      {
        path: 'outEntrepotFlowView',
        component: () => import('@/views/shipmentRequest/outEntrepotFlowView'),
        name: 'outEntrepotFlowView',
        meta: { title: '流程信息', activeMenu: '/shipment/outEntrepot' }
      }
    ]
  },
  {
    path: '/outEntrepot',
    component: Layout,
    hidden: true,
    permissions: ['shipment:outEntrepot:cwVerify','shipment:outEntrepot:ckVerify'],
    children: [
      {
        path: 'flowOutEntrepotAct',
        component: () => import('@/views/shipmentRequest/flowOutEntrepotAct'),
        name: 'flowOutEntrepotAct',
        meta: { title: '审批流程', activeMenu: '/shipment/outEntrepot' }
      }
    ]
  },


  //procedure---------------发货单审批
  {
    path: '/procedure',
    component: Layout,
    hidden: true,
    permissions: ['personalOffice:myMission:transaction'],
    children: [
      {
        path: 'flowShipment',
        component: () => import('@/views/procedure/flowShipment'),
        name: 'flowShipment',
        meta: { title: '发货单审批', activeMenu: '/personalOffice/myMission' }
      }
    ]
  },

  //客户信息审核
  {
    path: '/procedure',
    component: Layout,
    hidden: true,
    permissions: ['shipment:request:add'],
    children: [
      {
        path: 'flowCustomerInformation',
        component: () => import('@/views/procedure/flowCustomerInformation'),
        name: 'flowCustomerInformation',
        meta: { title: '客户信息审批', activeMenu: '/personalOffice/myMission' }
      }
    ]
  },
  {
    path: '/procedure',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'flowFrom',
        component: () => import('@/views/procedure/flowFrom'),
        name: 'flowFrom',
        meta: { title: '流程审批', activeMenu: '/personalOffice/myMission' }
      }
    ]
  },
  {
    path: '/procedure',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'relevanceFrom',
        component: () => import('@/views/procedure/relevanceFrom'),
        name: 'relevanceFrom',
        meta: { title: '关联表单', activeMenu: '/dashboard' }
      }
    ]
  },
//国际卡申请详情
  {
    path: '/international',
    component: Layout,
    hidden: true,
    permissions: ['international:applicationInfo:view'],
    children: [
      {
        path: 'applicationInfo/:id',
        component: () => import('@/views/international/application/info.vue'),
        name: 'internationalApplicationInfo',
        meta: { title: '国际卡申请详情', activeMenu: '/international/internationalApplicationList' }
      }
    ]
  },
  //国际卡网络信息
  {
    path: '/international',
    component: Layout,
    hidden: true,
    permissions: ['international:network:list'],
    children: [
      {
        path: 'network',
        component: () => import('@/views/international/network/index.vue'),
        name: 'internationalNetwork',
        meta: { title: '国际卡网络信息', activeMenu: '/international/network' }
      }
    ]
  },
]

// 防止连续点击多次路由报错
let routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}

export default new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})
